import { Rule } from "antd/lib/form"
import i18n from "~Shared/locales/i18n"
import { isEmptyString } from "~Shared/utils/helper.utils"

export const createSepaExportConfirmationRules = () => ({
    subjectLine: [
        {
            validator: (_rule, value: string) => {
                if (isEmptyString(value)) {
                    return Promise.reject(i18n.t("validation:required"))
                }
                if (value.length > 140) {
                    return Promise.reject(i18n.t("validation:below.string", { max: 140 }))
                }
                return Promise.resolve()
            },
        },
    ] as Array<Rule>,
})
